import React, { memo } from 'react';

import { TelexItem } from './TelexItem';

export const TelexList = memo(({ telegrams, onOfpClick, onClickTelegram, onAttachmentClick, getStyle }) => (
    <>
        {Object.keys(telegrams)
            .sort()
            .map((code) => (
                <TelexItem
                    key={code}
                    telegram={telegrams[code]}
                    onAttachmentClick={onAttachmentClick}
                    onClick={code === 'CFP' ? onOfpClick : onClickTelegram}
                    getStyle={getStyle}
                />
            ))}
    </>
));

TelexList.displayName = 'TelexList';
